import React, { Component } from 'react';
import "./landing.css"
class Landing extends Component {
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (
      <div className="landing">
       
        <div className="divStyle">  
            <div className="landform-body">
                    <div className="columns">
                        <div className="column is-half">
                            <div className="head-body">
                                <div className="head-body-sub">
                                    <h2 className="title is-3"><b>Medicio medical group</b></h2>
                                    <h2 className="subtitle is-4">Provide best quality healthcare for you</h2>
                                </div> 
                               
                                <div className="title-header-body">
                                    <article className="media">
                                            <figure className="media-left">
                                                <p className="image is-64x64">
                                                    <span className="icon is-small is-right font-check">
                                                            <i className="fas fa-check"></i>
                                                    </span>
                                                </p>
                                            </figure>
                                            <div className="media-content">
                                                
                                                    <p> 
                                                        Lorem ipsum dolormkdxngijkms  eros, eu  quis feugiat facilisis.
                                                    </p>
                                                
                                            </div>
                                    </article >
                                    <article className="media">
                                            <figure className="media-left">
                                                <p className="image is-64x64">
                                                    <span className="icon is-small is-right font-check">
                                                            <i className="fas fa-check"></i>
                                                    </span>
                                                </p>
                                            </figure>
                                            <div className="media-content">
                                                
                                                    <p> 
                                                        Lorem ipsuadipiscing elit. Proin ornare magna eros, eu  quis feugiat facilisis.
                                                    </p>
                                                
                                            </div>
                                    </article >
                                
                                    

                                </div>    

                            </div>    
                        
                        </div>

                        <div className="column is-half">
                            <div className="form-body">
                                <div className="form-title-body">  
                                <span className="icon font-title-body">
                                    <i className="fas fa-edit"></i>
                                    </span>
                                    <h6 className="title is-6 title-sub">Make an appoinment (It's free!)</h6>
                                </div>
                                <div className="form-body-sub">
                            < div className="columns">
                                    <div className="column is-half">
                                        <div className="field">
                                            <p className="control has-icons-left has-icons-right">
                                                <input className="input" type="email" placeholder="Email"/>
                                                <span className="icon is-small is-left">
                                                <i className="fas fa-envelope"></i>
                                                </span>
                                                <span className="icon is-small is-right">
                                                <i className="fas fa-check"></i>
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="column is-half">
                                        <div className="field">
                                            <p className="control has-icons-left">
                                                <input className="input" type="password" placeholder="Password" />
                                                <span className="icon is-small is-left">
                                                <i className="fas fa-lock"></i>
                                                </span>
                                            </p>
                                        </div>   
                                    </div>
                                    <br/>
                                </div>
                                <br/>
                                < div className="columns">
                                    <div className="column is-half">
                                        <div className="field">
                                            <p className="control has-icons-left has-icons-right">
                                                <input className="input" type="email" placeholder="Email"/>
                                                <span className="icon is-small is-left">
                                                <i className="fas fa-envelope"></i>
                                                </span>
                                                <span className="icon is-small is-right">
                                                <i className="fas fa-check"></i>
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="column is-half">
                                        <div className="field">
                                            <p className="control has-icons-left">
                                                <input className="input" type="password" placeholder="Password" />
                                                <span className="icon is-small is-left">
                                                <i className="fas fa-lock"></i>
                                                </span>
                                            </p>
                                        </div>   
                                    </div>
                                    <br/>
                                    


                                </div>
                                    
                                    <div className="field">
                                        <p className="control">
                                            <button className="button is-success">
                                            Login
                                            </button>
                                        </p>
                                    </div>
                                </div>    
                            </div>     
                        
                        </div>
                    </div>
                    <div className="borld">

                    </div> 

                    <div className="serach-body">
                       <div className="serach-sub"> 
                            <div className="field is-grouped">
                                    <p className="control is-expanded">
                                        <input className="input" type="text" placeholder="se" />
                                    </p>
                                    <p className="control">
                                        <a className="button is-info">
                                        Search
                                        </a>
                                    </p>
                            </div>
                       </div>
                    </div>      

                     <div className="what-we-do-body">
                            <div className="what-we-do">
                                <h3 className="title is-4 color-font"><b>In an emergency? Need help now?</b></h3>
                                <p className="subtitle is-5 color-font">Lorem ipsum dolor sit amet consectetur adipiscing elit uisque interdum ante eget faucibus.</p>
                             </div>

                            <div className="what-wedo-sub-body">
                                    <div className="columns">
                                        <div className="column is-half">
                                            <div className="what-we-do-phone">
                                                 <img src="http://www.peppement.com/f30a17b4efd6a29068b8232f5c3f74d9.png" width="260"/>
                                            </div>
                                        </div>
                                        <div className="column is-half">
                                          <div className="what-wedo-sub">
                                          <br/>
                                                <div className="columns">
                                                    <div className="column is-half">
                                                        <article className="media">
                                                                <figure className="media-left">
                                                                    <p className="image is-64x64">
                                                                        <span className="icon is-small is-right font-check">
                                                                                <i className="fas fa-check"></i>
                                                                        </span>
                                                                    </p>
                                                                </figure>
                                                                <div className="media-content">
                                                                        <p> 
                                                                            Lorem ipsuadipiscing elit. Proin ornare magna eros, eu  quis feugiat facilisis.
                                                                        </p>
                                                                </div>
                                                        </article >
                                                    </div>
                                                    <div className="column is-half">
                                                        <article className="media">
                                                                <figure className="media-left">
                                                                    <p className="image is-64x64">
                                                                        <span className="icon is-small is-right font-check">
                                                                                <i className="fas fa-check"></i>
                                                                        </span>
                                                                    </p>
                                                                </figure>
                                                                <div className="media-content">
                                                                        <p> 
                                                                            Lorem ipsuadipiscing elit. Proin ornare magna eros, eu  quis feugiat facilisis.
                                                                        </p>
                                                                </div>
                                                        </article >
                                                    </div>
                                                </div>
                                                <br/>
                                                <div className="columns">
                                                    <div className="column is-half">
                                                        <article className="media">
                                                                <figure className="media-left">
                                                                    <p className="image is-64x64">
                                                                        <span className="icon is-small is-right font-check">
                                                                                <i className="fas fa-check"></i>
                                                                        </span>
                                                                    </p>
                                                                </figure>
                                                                <div className="media-content">
                                                                        <p> 
                                                                            Lorem ipsuadipiscing elit. Proin ornare magna eros, eu  quis feugiat facilisis.
                                                                        </p>
                                                                </div>
                                                        </article >
                                                    </div>
                                                    <div className="column is-half">
                                                        <article className="media">
                                                                <figure className="media-left">
                                                                    <p className="image is-64x64">
                                                                        <span className="icon is-small is-right font-check">
                                                                                <i className="fas fa-check"></i>
                                                                        </span>
                                                                    </p>
                                                                </figure>
                                                                <div className="media-content">
                                                                        <p> 
                                                                            Lorem ipsuadipiscing elit. Proin ornare magna eros, eu  quis feugiat facilisis.
                                                                        </p>
                                                                </div>
                                                        </article >
                                                    </div>
                                                </div>
                                                <br/>
                                                <div className="columns">
                                                    <div className="column is-half">
                                                        <article className="media">
                                                                <figure className="media-left">
                                                                    <p className="image is-64x64">
                                                                        <span className="icon is-small is-right font-check">
                                                                                <i className="fas fa-check"></i>
                                                                        </span>
                                                                    </p>
                                                                </figure>
                                                                <div className="media-content">
                                                                        <p> 
                                                                            Lorem ipsuadipiscing elit. Proin ornare magna eros, eu  quis feugiat facilisis.
                                                                        </p>
                                                                </div>
                                                        </article >
                                                    </div>
                                                    <div className="column is-half">
                                                        <article className="media">
                                                                <figure className="media-left">
                                                                    <p className="image is-64x64">
                                                                        <span className="icon is-small is-right font-check">
                                                                                <i className="fas fa-check"></i>
                                                                        </span>
                                                                    </p>
                                                                </figure>
                                                                <div className="media-content">
                                                                        <p> 
                                                                            Lorem ipsuadipiscing elit. Proin ornare magna eros, eu  quis feugiat facilisis.
                                                                        </p>
                                                                </div>
                                                        </article >
                                                    </div>
                                                </div>

                                            </div>    
                                        </div>
                                    </div>  
                            </div>     
                           
                     </div>

                      
                     
            </div>
            {/* Herd body end here */}
            <div className="step-body">
                     <div className="body-arrow">  
                               <div className="flow-arrow">  </div>
                    </div> 

                    <div className="step-sub">
                        <div className="columns">
                                <div className="column">
                                    <div className="box-step"> 
                                       <div className="values-unit" id="values-unit-1">
                                                <h3 className="num">1</h3>
                                                <i className="fas fa-search icon-font"></i>   
                                             <div className="box-step-title"> 
                                                     
                                                <p>Your personal design consultant meets with you to discuss style, preferences and space.</p>
                                              
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div className="box-step"> 
                                        <div className="values-unit" id="values-unit-1">
                                                    <h3 className="num">2</h3>
                                                    <i className="far fa-eye icon-font"></i> 
                                                <div className="box-step-title"> 
                                                        
                                                    <p>Your personal design consultant meets with you to discuss style, preferences and space.</p>
                                                
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="column">
                                  <div className="box-step"> 
                                        <div class="values-unit" id="values-unit-1">
                                                    <h3 className="num">3</h3>
                                                    <i className="far fa-credit-card icon-font"></i>
                                                    
                                                <div className="box-step-title"> 
                                                        
                                                    <p>Your personal design consultant meets with you to discuss style, preferences and space.</p>
                                                
                                                </div>
                                        </div>
                                    </div>
                                 </div>
                                
                        </div>
                   </div>
            </div>    
            
            

       </div>
       



       <footer className="footer land-footer">
            <div className="content has-text-centered">
                <p>
                <strong>Bulma</strong> by <a href="https://jgthms.com">Jeremy Thomas</a>. The source code is licensed
                <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
                is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
                </p>
            </div>
      </footer>
      
       
    
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/component/landing/landing.js